<script>
import BaseApp from '../../BaseApp.vue';

export default {
  name: "NotFound",
  mixins: [BaseApp],
  beforeRouteEnter(to) {
    if (to.name === 'not_found') {
      window.location.href = '/shop/cart/';
    }
  },
}
</script>